const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTiny(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3606 3577",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2296.703,2225.931C2296.703,2476.224 2073.833,2679.431 1799.318,2679.431C1524.804,2679.431 1301.933,2476.224 1301.933,2225.931C1301.933,1975.637 1525.677,1766.38 1800.191,1766.38L1954.49,1766.38L1954.49,1144.174L2296.634,798.42L2298.449,2225.931L2296.703,2225.931Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3173.279,895.943L3601.047,895.943L3601.047,3571.842L477.248,3571.842L908.195,3148.651L3173.279,3148.651L3173.279,895.943Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.167,4.167L4.167,2679.431L425.104,2679.431L425.104,403.054L2677.701,403.054L3074.902,5.853L4.167,4.167Z",
    style: {
      stroke: "#fffaff",
      fill: "#fffaff",
      strokeWidth: "8.33px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTiny);
export default __webpack_public_path__ + "static/media/logo-tiny.d1b2bc3b6965f6cb20de6860930716f7.svg";
export { ForwardRef as ReactComponent };